export interface IJobSearchPageContent {
    filterLabelText: string;
    countryFilterLabelText: string;
    countryFilterPlaceholderText: string;
    stateFilterLabelText: string;
    stateFilterPlaceholderText: string;
    cityFilterLabelText: string;
    cityFilterPlaceholderText: string;
    businessAreaFilterLabelText: string;
    businessAreaFilterPlaceholderText: string;
    resultLinkText: string;
    resultBusinessAreaLabelText: string;
    resultLocationLabelText: string;
    searchErrorText: string;
    pageSize: number;
    pageText: string;
    resultCountText: string;
    noResultsText: string;
    header: string;
    imageUrl: string;
    searchTextboxLabel: string;
    searchTextboxPlaceholder: string;
    imageAltText: string;
}

export const DefaultJobSearchPageContent = {
    filterLabelText: '',
    countryFilterLabelText: '',
    countryFilterPlaceholderText: '',
    stateFilterLabelText: '',
    stateFilterPlaceholderText: '',
    cityFilterLabelText: '',
    cityFilterPlaceholderText: '',
    businessAreaFilterLabelText: '',
    businessAreaFilterPlaceholderText: '',
    resultLinkText: '',
    resultBusinessAreaLabelText: '',
    resultLocationLabelText: '',
    searchErrorText: '',
    pageSize: 10,
    pageText: '',
    resultCountText: '',
    noResultsText: '',
    header: '',
    imageUrl: '',
    searchTextboxLabel: '',
    searchTextboxPlaceholder: '',
    imageAltText: '',
}